import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BackpackIconsModule } from 'app/backpack-icons/backpack-icons.module';
import { CoreModule } from 'app/core/core.module';
import { AttendanceRecord } from 'app/models';
import { ExclusionGroupWithOverrides } from 'app/services/encounter-prevention.service';
import { HomepageService } from 'app/services/homepage.service';
import { User } from '../models/User';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	selector: 'sp-student-list-item',
	template: `
		<div
			*ngIf="student"
			class="student-item"
			(mouseenter)="hovered.emit(true)"
			(mouseleave)="hovered.emit(false)"
			[ngClass]="{ 'disable-bg-hover': disableBGHover }">
			<div class="student-tag">
				<span *ngIf="ordered" class="order-indicator">
					{{ index + 1 | position }}
				</span>
				<div
					*ngIf="student.profile_picture; else defaultProfilePicture"
					[ngStyle]="{ background: 'url(' + student.profile_picture + ') no-repeat left center/cover' }"
					[ngClass]="{ 'tw-opacity-50': attendance?.state === 'absent' }"
					class="profile-picture"></div>
				<ng-template #defaultProfilePicture>
					<img class="profile-picture" src="../../../../../assets/Avatar Default.svg" alt="Avatar" />
				</ng-template>
				<div (click)="homePageService.goToStudentPage(student.id)">
					<span class="name" [ngClass]="{ 'tw-opacity-50': attendance?.state === 'absent' }">{{ student.display_name }}</span>
				</div>
				<div *ngIf="groups && groups.length > 0 && !kioskMode" class="tw-animate-fadein-300 tw-w-5 tw-h-5 tw-ml-2">
					<bp-icon icon="feature-encounter-prevention" customToolTip [contentTemplate]="tooltip" [toolTipHideDelay]="300"></bp-icon>
				</div>
				<div class="tw-pl-2">
					<ng-content select="[sp-student-list-item-left]"></ng-content>
				</div>
			</div>
			<div class="student-item-right-side">
				<ng-content select="[sp-student-list-item-right]"></ng-content>
			</div>
		</div>
		<ng-template #tooltip>
			<app-encounter-prevention-tooltip [user]="user" [groups]="groups"></app-encounter-prevention-tooltip>
		</ng-template>
	`,
	styleUrls: ['./student-list-item.component.scss'],
	imports: [CommonModule, CoreModule, BackpackIconsModule],
})
export class StudentListItemComponent implements OnInit {
	@Input() student: User | null = null;
	@Input() user!: User;
	@Input() ordered!: boolean;
	@Input() index!: number;
	@Input() groups: ExclusionGroupWithOverrides[] = [];
	@Input() disableBGHover = false;
	@Input() attendance?: AttendanceRecord | null | undefined;
	@Output() hovered = new EventEmitter<boolean>();

	kioskMode!: boolean;

	constructor(public homePageService: HomepageService) {}

	ngOnInit(): void {
		this.kioskMode = this.homePageService.isKioskMode;
	}
}
